import { Map, fromJS } from 'immutable';

export function request(state, { marketId, dividendType, dividendId, data }) {
    return state.set(
        'update-dividend',
        (state.get('update-dividend') || Map())
            .set(marketId, Map({
                type: dividendType,
                dividend: fromJS(data),
                state: 'IN_PROGRESS',
                dividendId
            }))
    );
}

export function error(state, { marketId, dividentId, errors }) {
    return state.set(
        'update-dividend',
        (state.get('update-dividend') || Map())
            .set(marketId, Map({
                dividend: state.getIn([ 'update-dividend', marketId, 'dividend' ]),
                state: 'ERROR',
                errors: fromJS(errors),
                dividendId
            }))
    );
}

export function finish(state, { marketId, dividendId, market }) {
    return state
        .set(
            'update-dividend',
            (state.get('update-dividend') || Map())
                .set(marketId, Map({
                    dividend: state.getIn([ 'update-dividend', marketId, 'dividend' ]),
                    state: 'FINISHED',
                    dividendId
                }))
        )
        .setIn([ 'items', market.id ], fromJS(market));
}
